'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = require('react');

var ReactDOM = require('react-dom');

var A11yDialog = require('a11y-dialog');

var Dialog = function (_React$Component) {
  _inherits(Dialog, _React$Component);

  function Dialog(props) {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

    _this.state = {
      isMounted: false,
      container: null
    };
    _this.initDialog = _this.initDialog.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }

  _createClass(Dialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.container !== this.state.container && this.state.container) {
        this.dialog = this.dialog || this.initDialog();
        this.props.dialogRef(this.dialog);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.dialog) {
        this.dialog.destroy();
      }

      this.props.dialogRef(undefined);
    }
  }, {
    key: 'initDialog',
    value: function initDialog() {
      return new A11yDialog(this.state.container, this.props.appRoot);
    }
  }, {
    key: 'close',
    value: function close() {
      this.dialog.hide();
    }
  }, {
    key: 'handleRef',
    value: function handleRef(element) {
      this.setState({
        container: element
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.isMounted) {
        return null;
      }

      var _props = this.props,
          id = _props.id,
          classNames = _props.classNames;
      var titleId = this.props.titleId || id + '-title';
      var Element = this.props.useDialog ? 'dialog' : 'div';
      return ReactDOM.createPortal(React.createElement('div', {
        id: id,
        className: classNames.base,
        ref: this.handleRef
      }, React.createElement('div', {
        tabIndex: '-1',
        className: classNames.overlay,
        onClick: this.props.role === 'alertdialog' ? undefined : this.close
      }), React.createElement(Element, {
        role: this.props.role,
        className: classNames.element,
        'aria-labelledby': titleId
      }, React.createElement('div', {
        role: this.props.useDialog ? undefined : 'document',
        className: classNames.document
      }, React.createElement('button', {
        type: 'button',
        'aria-label': this.props.closeButtonLabel,
        onClick: this.close,
        className: classNames.closeButton
      }, this.props.closeButtonContent), React.createElement('h1', {
        id: titleId,
        className: classNames.title
      }, this.props.title), this.props.children))), document.querySelector(this.props.dialogRoot));
    }
  }]);

  return Dialog;
}(React.Component);

Dialog.defaultProps = {
  role: 'dialog',
  closeButtonLabel: 'Close this dialog window',
  closeButtonContent: '\xD7',
  classNames: {},
  dialogRef: function dialogRef() {
    return void 0;
  },
  useDialog: true // Default properties cannot be based on other properties, so the default
  // value for the `titleId` prop is defined in the `render(..)` method.

};
module.exports = Dialog;